import { render, staticRenderFns } from "./CoinNetworkPlan.vue?vue&type=template&id=15427d7c&scoped=true&"
import script from "./CoinNetworkPlan.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkPlan.vue?vue&type=style&index=0&id=15427d7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15427d7c",
  null
  
)

export default component.exports